import auth from "./auth/reducer";
import error from "./error/reducer";
import form from "./form/reducer";
import meta from "./meta/reducer";
export default { auth, meta, form, error };
